import React from 'react';
import { FiX, FiAward, FiInstagram, FiSend, FiPhone, FiCalendar } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

const TrainerDetailsModal = ({ trainer, achievements, onClose }) => {
  const { t } = useTranslation();
  if (!trainer) return null;

  const trainerAchievements = achievements.filter(a => a.trainerId === trainer.id);

  return (
    <div className="details-modal-overlay" onClick={onClose}>
      <div className="details-modal" onClick={e => e.stopPropagation()}>
        <button className="details-modal-close" onClick={onClose}>
          <FiX />
        </button>

        {/* Left: Image */}
        <div style={{ height: '100%', minHeight: 400 }}>
          <img 
            src={trainer.mediaUrl || 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=800&q=80'} 
            alt={trainer.fullName} 
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </div>

        {/* Right: Info */}
        <div style={{ padding: 40 }}>
          <span className="section-label" style={{ marginBottom: 12 }}>{t('trainer_modal.profile')}</span>
          <h1 style={{ fontSize: '2rem', fontWeight: 900, marginBottom: 8, color: 'var(--text-primary)' }}>
            {trainer.fullName}
          </h1>
          <p style={{ color: 'var(--accent)', fontWeight: 700, fontSize: '1.1rem', marginBottom: 20 }}>
            {trainer.position}
          </p>

          <div style={{ display: 'flex', gap: 24, marginBottom: 32 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'var(--text-secondary)' }}>
              <FiCalendar /> <span>{t('trainers_page.age')}: {trainer.age || '—'}</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'var(--text-secondary)' }}>
              <FiPhone /> <span>{trainer.phone || '—'}</span>
            </div>
          </div>

          <div style={{ marginBottom: 32 }}>
            <h3 style={{ fontSize: '1rem', fontWeight: 800, marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
              <FiAward style={{ color: 'var(--orange)' }} /> {t('trainer_modal.achievements_title')}
            </h3>
            
            {trainerAchievements.length === 0 ? (
              <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>{t('trainer_modal.no_achievements')}</p>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                {trainerAchievements.map(ach => (
                  <div key={ach.id} style={{ padding: 16, background: 'var(--bg-secondary)', borderRadius: 'var(--radius)', border: '1px solid var(--border)' }}>
                    <h4 style={{ fontSize: '0.92rem', fontWeight: 700, marginBottom: 4 }}>{ach.name}</h4>
                    <p style={{ fontSize: '0.85rem', color: 'var(--text-secondary)', lineHeight: 1.5 }}>{ach.description}</p>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div>
            <h3 style={{ fontSize: '1rem', fontWeight: 800, marginBottom: 16 }}>{t('trainer_modal.connect')}</h3>
            <div style={{ display: 'flex', gap: 12 }}>
              {trainer.instagramLink && (
                <a href={trainer.instagramLink} target="_blank" rel="noopener noreferrer" className="btn btn-outline btn-sm" style={{ gap: 8 }}>
                  <FiInstagram /> Instagram
                </a>
              )}
              {trainer.telegramLink && (
                <a href={trainer.telegramLink} target="_blank" rel="noopener noreferrer" className="btn btn-outline btn-sm" style={{ gap: 8 }}>
                  <FiSend /> Telegram
                </a>
              )}
              <a href={`tel:${trainer.phone}`} className="btn btn-primary btn-sm" style={{ gap: 8 }}>
                <FiPhone /> {t('trainer_modal.contact_now')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrainerDetailsModal;
